<template>
    <div class="container">
        <b-container fluid v-if="!showPage">
              <b-row>
                <div class="text-center m-5">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>&nbsp;Loading...</strong>
                </div>
              </b-row>
        </b-container>   
        <b-container fluid v-if="showPage" style="margin-top:100px;">
            <b-row>
                <b-col>
                    <Plotly :data="condGraphData" :layout="Condlayout" :display-mode-bar="false" :autoResize="true"></Plotly>
                </b-col>
                <b-col>
                    <Plotly :data="uncondGraphData" :layout="UnCondlayout" :display-mode-bar="false" :autoResize="true"></Plotly>
                </b-col>
            </b-row>
            <b-row style="align:left">
                <b-col style="align:left">
                    <div id="boxBg">
                        <b>Note:</b>
                        A significant proportion of samples changed their enterotypes after FMT, such change is significantly 
                            affected by diets of recipient mice. The entrotypes was calculated using the method described in paper: 
                            <b> Arumugam, M., Raes, J., Pelletier, E. et al. Enterotypes of the human gut microbiome. Nature 473, 174–180 (2011). <a href="https://doi.org/10.1038/nature09944" target="_blank"> DOI</a></b>
                        <ul>
                            <li> Enterotype changes in the “controlled diet” group, i.e. recipient 
                            mice were fed with human food.</li>
                            <li> Enterotype changes in the “uncontrolled diet” group, i.e. recipient 
                            mice were fed with mouse food.</li>
                        </ul>
                    </div>
                    <br>
                </b-col>
            </b-row>   
            <b-card  align="left">
                <b-card-body>
                    <b-row style="margin-top:10px;margin-bottom:10px">
                            <b-col style="align:left">                       
                                <b-input-group>
                                    <b-form-input
                                    v-model="filter"
                                    type="search"
                                    id="filterHmPairs"
                                    placeholder="Type to Search"
                                    ></b-form-input>
                                    <b-input-group-append>
                                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>
                    </b-row>
                    <b-row style="align:left">
                        <b-col>
                            <div id="boxBg">
                                <b>Note:</b>
                                <p>For complex <b>search</b> queries use,
                                    <ul>
                                        <li><b>AND</b>: To filter rows based on two or more conditions (columns) match. </li>
                                        <li><b>OR</b> : To filter rows even if one condition (column) match. </li>
                                        <li>Only use one type of operator in an query(Either AND or OR, but not together.)</li>
                                    </ul>
                                    Examples:
                                    <ul>
                                        <li>mouse1 <b>AND</b> human2</li>
                                        <li>mouse1 <b>OR</b> human3</li>
                                        <li>mouse1 <b>AND</b> human2 <b>AND</b> controlled diet</li>
                                        <li>mouse1 <b>AND</b> human2 <b>AND</b> non-controlled diet</li>
                                    </ul>
                                </p>
                            </div>
                        </b-col>
                    </b-row>
                    <!-- <b-row>
                        <b-col style="align:left"> 
                            <label >Filter by</label>
                        </b-col>
                    </b-row>
                    <b-row>
                       <b-col style="align:left"> 
                               <b-form-select v-model="selectedME" :options="mouseEntropyOptions"></b-form-select>
                        </b-col>
                        <b-col style="align:left"> 
                                <b-form-select v-model="selectedHE" :options="humanEntropyOptions"></b-form-select>
                        </b-col>
                        <b-col style="align:left">
                                <b-form-select v-model="selecteddietOp" :options="dietOptions"></b-form-select>
                        </b-col> 
                    </b-row> -->
                </b-card-body>    
            </b-card>
            <br/>
            <b-row>
                <b-col align-self="center">
                    <b-table
                                responsive
                                show-empty
                                :busy.sync="isBusy"
                                :striped="false"
                                :outlined="true"
                                :items="tab_data"
                                :fields="tab_fields"
                                :current-page="currentPage"
                                :per-page="perPage"
                                :filter="filter"
                                :filter-function="filterTable"
                            >
                            <template  v-slot:table-busy>
                                      <div class="text-center text-danger my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                        <strong>Loading...</strong>
                                      </div>
                                    </template>
                            <template v-slot:cell(bioProject) ="row">
                                <a v-bind:href="'https://www.ncbi.nlm.nih.gov/bioproject/' + row.item.bioProject.trim()" target="_blank">{{row.item.bioProject.trim()}} <font-awesome-icon icon="external-link-square-alt" size='sm'></font-awesome-icon></a>
                            </template>
                            <template v-slot:cell(humanRun) ="row">
                                <a v-bind:href="'https://trace.ncbi.nlm.nih.gov/Traces/sra/?run=' + row.item.humanRun.trim()" target="_blank">{{row.item.humanRun.trim()}} <font-awesome-icon icon="external-link-square-alt" size='sm'></font-awesome-icon></a>
                            </template>
                            <template v-slot:cell(mouseRun) ="row">
                                <a v-bind:href="'https://trace.ncbi.nlm.nih.gov/Traces/sra/?run=' + row.item.mouseRun.trim()" target="_blank">{{row.item.mouseRun.trim()}} <font-awesome-icon icon="external-link-square-alt" size='sm'></font-awesome-icon></a>
                            </template>
                            <template v-slot:cell(viewpair)="data">
                                <router-link :to="{ path: '/viewpair/p/'+data.item.humanRun.trim()+'/'+data.item.mouseRun.trim()}" target="_blank" >
                                    <b-button size="sm" variant="primary">View</b-button>
                                </router-link> 
                            </template>
                        </b-table>
                        <b-row>
                            <b-col md="6" class="my-1">
                                <b-pagination
                                v-model="currentPage"
                                :total-rows="totalRows"
                                :per-page="perPage"
                                class="my-0"
                                ></b-pagination>
                            </b-col>
                            <b-col md="6" class="my-1">
                                <b-form-group label-cols-sm="3" label="Per page" class="mb-0">
                                <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>                    
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import axios from 'axios'
import Vue from 'vue'

export default {
    data () {
        return{
            server_add:this.$hostname,
            showPage:false,
            loadCounter:0,
            humanSpOptions:[],
            mouseSpOptions:[],
            condGraphData:[
            ],
            uncondGraphData:[
            ],
            Condlayout:{
                title: "Controlled Diet"
            },
            UnCondlayout:{
                title: "Non-controlled Diet"
            },
            humanSp:{
                value:'',
                text:''
            },
            mouseSp:{
                value:'',
                text:''
            },
            filter:null,
            isBusy:true,
            tab_data:[],
            tab_fields:[
                    { key:'bioProject',label:'Project ID',sortable:true },
                    { key: 'mouseRun', label: 'Mouse Run ID', sortable: true },
                    { key: 'humanRun', label: 'Human Run ID', sortable: true},
                    { key: 'mouseEnterotype', label: 'Mouse cluster enterotype', sortable: true},
                    { key: 'humanEnterotype', label: 'Human cluster enterotype', sortable: true},
                    { key:'fedMethod',label:'Fed method',sortable:false },
                    { key:'condition',label:'Dietery condition',sortable:false },
                    { key:'viewpair',label:''},                    
            ],
            totalRows: 1,
            currentPage: 1,
            perPage: 15,
            pageOptions: [5, 10, 15,25],
            selectedME:'all Mouse entropy',
            selectedHE:'all Human entropy',
            selecteddietOp:'all diet',
            mouseEntropyOptions:['all Mouse entropy','mouse1','mouse2','mouse3'],
            humanEntropyOptions:['all Human entropy','human1','human2','human3'],
            dietOptions:['all diet','controlled diet','non-controlled diet']
        }
    },
    mounted() {
        this.loadHmPairTable()
        this.loadGraph()                
    },
    methods: {
        loadHmPairTable(){
            axios.post(this.server_add+'query/listHmPair',
            {
            }).then(retDat => {
                if(retDat.status === 200){
                    this.tab_data = retDat.data
                    this.totalRows = retDat.data.length
                    this.isBusy = false
                    this.loadCounter++
                }
            }).catch(err => {
                console.log(err)
            })
        },
        loadGraph(){            
            axios.post(this.server_add+'query/getOverAllEntropy',
            {
            }).then(retDat => {
                if(retDat.status == 200){
                    // console.log(retDat.data.cond_diet)
                    // var cond_color = retDat.data.cond_diet[0].values;
                    // var colorscale = [[1, 'red'], [2, 'lightsteelblue'],[3, 'mediumseagreen']];
                    var trace1 = {
                        type: 'parcats',
                        dimensions: retDat.data.cond_diet,
                        // line: {color: cond_color,
                        //         colorscale: colorscale},
                    };
                    this.condGraphData.push(trace1)
                    var trace2 = {
                        type: 'parcats',
                        dimensions: retDat.data.uncond_diet,
                        categoryorder:"category ascending"
                    }
                    this.uncondGraphData.push(trace2)
                    this.loadCounter++
                }
            }).catch(err => {
                console.log(err)
            })
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
        filterTable(row,filter) {
            var hasAss = false
            if(filter.includes('AND')){
                var andAr = filter.split('AND')
                hasAss = this.isPresent(row,andAr,1)
            }else if(filter.includes('OR')){
                var orAr = filter.split('OR')
                hasAss = this.isPresent(row,orAr,2)
            }else if(filter.includes(row.mouseRun) || filter.includes(row.humanRun) || filter.includes(row.mouseEnterotype) || filter.includes(row.humanEnterotype)){
                hasAss = true
            }            
            return hasAss;            
        },
        isPresent(row,array,typ){
            let counter = 0
            for(let ind = 0;ind<array.length;ind++){
                var val = array[ind].trim()
                if(val === (row.mouseRun) || val === (row.humanRun) || val === (row.mouseEnterotype) || val === (row.humanEnterotype) || val === row.fedMethod){
                    counter+=1
                }
            }
            if(counter === array.length && typ === 1){
                return true
            }else if(counter >=1 && typ === 2){
                return true
            }
            return false
        },
        checkStatus(){
            if(this.loadCounter>=1){
                this.showPage = true
            }
        }
    },
    watch: {
        loadCounter: function(newValue, oldValue) {
            this.showPage   = newValue>=2
        }
    },
}

</script>

<style lang="less">
    #boxBg{
    background-color: #ECE9E9;
    padding-top: 10px;
    padding-bottom: 5px;
    padding-left: 5px;
    align-content: left;
}
</style>